import { branches } from '../helpers/Executive-Dashboard/branch-condition';
import { surroundingSys } from './api';

/**
 * Fetch pre-aggregated dashboard summary from the backend.
 * All data processing (top customers, revenue trends, KPIs)
 * is done server-side via MongoDB aggregation.
 *
 * @returns {Object} { kpis, topCustomers, topItems, revenueTrend, paymentBreakdown, recentInvoices }
 */
export const fetchDashboardSummary = async (config, branch = '') => {
    const params = {
        company_id: config.company_id,
        system_name: config.system_name,
        branch: branches(branch)
    };
    const response = await surroundingSys.get('/executive/summary', { params });
    if (response.data?.success) {
        return response.data.data;
    }
    throw new Error(response.data?.message || 'Failed to fetch dashboard data');
};

export const fetchSalesProgress = async (month, year, mode, config, branch) => {
    const params = {};
    if (mode) params.mode = mode;
    if (month) params.month = month;
    if (year) params.year = year;
    params.company_id = config.company_id;
    params.system_name = config.system_name;
    params.branch = branches(branch);
    
    const response = await surroundingSys.get('/executive/sales-progress', { params });
    if (response.data?.success) {
        return response.data.data;
    }
    throw new Error(response.data?.message || 'Failed to fetch sales progress');
};

export const fetchRevenueTrend = async (period, month, year, config, branch) => {
    const params = { period };
    if (period === 'daily' && month) params.month = month;
    if (period !== 'yearly' && year) params.year = year;
    params.company_id = config.company_id;
    params.system_name = config.system_name;
    params.branch = branches(branch);

    const response = await surroundingSys.get('/executive/revenue-trend', { params });
    if (response.data?.success) {
        return response.data.data;
    }
    throw new Error(response.data?.message || 'Failed to fetch revenue trend');
};

export const fetchSellerPerformance = async (mode, month, year, config, branch) => {
    const params = { mode };
    if (mode === 'permonth') {
        if (month) params.month = month;
        if (year) params.year = year;
    }
    params.company_id = config.company_id;
    params.system_name = config.system_name;
    params.branch = branches(branch);

    const response = await surroundingSys.get('/executive/seller-performance', { params });
    if (response.data?.success) {
        return response.data.data;
    }
    throw new Error(response.data?.message || 'Failed to fetch seller performance');
};

export const fetchTopCustomer = async (mode, month, year, config, branch) => {
    const params = {};
    if (mode) params.mode = mode;
    if (month) params.month = month;
    if (year) params.year = year;

    params.company_id = config.company_id;
    params.system_name = config.system_name;
    params.branch = branches(branch);
    
    const response = await surroundingSys.get('/executive/top-customer', { params });
    if (response.data?.success) {
        return response.data.data.topCustomers;
    }
    throw new Error(response.data?.message || 'Failed to fetch top customer');
}

export const fetchTopProduct = async (mode, month, year, config, branch) => {
    const params = {};
    if (mode) params.mode = mode;
    if (month) params.month = month;
    if (year) params.year = year;

    params.company_id = config.company_id;
    params.system_name = config.system_name;
    params.branch = branches(branch);
    
    const response = await surroundingSys.get('/executive/top-item', { params });
    if (response.data?.success) {
        return response.data.data.topItems;
    }
    throw new Error(response.data?.message || 'Failed to fetch top product');
}

export const fetchBranches = async (config) => {
    const params = {};

    params.company_id = config.company_id;
    params.system_name = config.system_name;
    
    const response = await surroundingSys.get('/executive/fetch-branch', { params });
    if (response.data?.success) {
        return response.data.data.branchSelected;
    }
    throw new Error(response.data?.message || 'Failed to fetch branch');
}